import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M26.667 21.333a5.339 5.339 0 00-5.225 4.267h-4.375V6.4h4.375a5.34 5.34 0 005.225 4.267A5.338 5.338 0 0032 5.333 5.338 5.338 0 0026.667 0a5.339 5.339 0 00-5.225 4.267H16c-.589 0-1.067.478-1.067 1.066v9.6h-4.375a5.339 5.339 0 00-5.225-4.266A5.338 5.338 0 000 16a5.338 5.338 0 005.333 5.333 5.339 5.339 0 005.225-4.266h4.375v9.6c0 .588.478 1.066 1.067 1.066h5.442A5.34 5.34 0 0026.667 32 5.338 5.338 0 0032 26.667a5.338 5.338 0 00-5.333-5.334zm0-19.2c1.764 0 3.2 1.436 3.2 3.2 0 1.765-1.436 3.2-3.2 3.2a3.204 3.204 0 01-3.2-3.2c0-1.764 1.435-3.2 3.2-3.2zM5.333 19.2a3.204 3.204 0 01-3.2-3.2c0-1.764 1.436-3.2 3.2-3.2 1.765 0 3.2 1.436 3.2 3.2 0 1.764-1.435 3.2-3.2 3.2zm21.334 10.667a3.204 3.204 0 01-3.2-3.2c0-1.765 1.435-3.2 3.2-3.2 1.764 0 3.2 1.435 3.2 3.2 0 1.764-1.436 3.2-3.2 3.2z"></path>
        </svg>
    );
}